import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLinkAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1872 4.81284C17.1369 2.76258 13.8128 2.76258 11.7626 4.81284L9.34834 7.22705C9.05545 7.51994 9.05545 7.99482 9.34834 8.28771C9.64124 8.5806 10.1161 8.5806 10.409 8.28771L12.8232 5.8735C14.2877 4.40903 16.6621 4.40903 18.1265 5.8735C19.591 7.33796 19.591 9.71233 18.1265 11.1768L15.7123 13.591C15.4194 13.8839 15.4194 14.3588 15.7123 14.6517C16.0052 14.9446 16.4801 14.9446 16.773 14.6517L19.1872 12.2375C21.2374 10.1872 21.2374 6.86309 19.1872 4.81284Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.28768 10.409C8.58058 10.1161 8.58058 9.64126 8.28768 9.34837C7.99479 9.05548 7.51992 9.05548 7.22703 9.34837L4.81281 11.7626C2.76256 13.8128 2.76256 17.137 4.81281 19.1872C6.86306 21.2375 10.1872 21.2375 12.2374 19.1872L14.6516 16.773C14.9445 16.4801 14.9445 16.0052 14.6516 15.7123C14.3588 15.4194 13.8839 15.4194 13.591 15.7123L11.1768 18.1265C9.7123 19.591 7.33793 19.591 5.87347 18.1265C4.409 16.6621 4.409 14.2877 5.87347 12.8232L8.28768 10.409Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6517 10.409C14.9445 10.1161 14.9445 9.64126 14.6517 9.34837C14.3588 9.05548 13.8839 9.05548 13.591 9.34837L9.34835 13.591C9.05546 13.8839 9.05546 14.3588 9.34835 14.6517C9.64125 14.9446 10.1161 14.9446 10.409 14.6517L14.6517 10.409Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconLinkAlt as ReactComponent };
